import Medico1 from "./../assets/images/Medico-1.png";
import Medico2 from "./../assets/images/Medico-2.png";
import Medico3 from "./../assets/images/Medico-3.png";
import Medico4 from "./../assets/images/Medico-4.png";

import Reabilitacao1 from "./../assets/images/Reabilitacao-1.png";
import Reabilitacao2 from "./../assets/images/Reabilitacao-2.png";
import Reabilitacao3 from "./../assets/images/Reabilitacao-3.png";
import Reabilitacao4 from "./../assets/images/Reabilitacao-4.png";
import Reabilitacao5 from "./../assets/images/Reabilitacao-5.png";
import Reabilitacao6 from "./../assets/images/Reabilitacao-6.png";
import Reabilitacao7 from "./../assets/images/robotica.png";
import Reabilitacao8 from "./../assets/images/musico.png";

import Assistencia1 from "./../assets/images/Assistencia-1.png";
import Assistencia2 from "./../assets/images/Assistencia-2.png";

import Ortopedica from "./../assets/images/Ortopedica-1.png";

export const medicalServices = [
  {
    id: 1,
    title: "Neuropediatria",
    image: Medico1,
    description: "Descrição do serviço de Neuropediatria.",
  },
  {
    id: 2,
    title: "Ortopedia",
    image: Medico3,
    description: "Descrição do serviço de Ortopedia.",
  },
  {
    id: 3,
    title: "Oftamologia",
    image: Medico2,
    description: "Descrição do serviço de Oftamologia.",
  },
  {
    id: 4,
    title: "Otorrinolaringologia",
    image: Medico4,
    description: "Descrição do serviço de Otorrinolaringologia.",
  },
];

export const rehabilitationServices = [
  {
    id: 4,
    title: "Enfermagem",
    image: Reabilitacao1,
    description: "Descrição do serviço de Enfermagem.",
  },
  {
    id: 5,
    title: "Fisioterapia Neurofuncional",
    image: Reabilitacao2,
    description: "Fisioterapia voltada para reabilitação.",
  },
  {
    id: 6,
    title: "Fisioterapia Respiratória",
    image: Reabilitacao3,
    description: "Auxílio na melhora da função respiratória.",
  },
  {
    id: 7,
    title: "Psicologia",
    image: Reabilitacao4,
    description: "Apoio psicológico ao paciente.",
  },
  {
    id: 8,
    title: "Terapia Ocupacional",
    image: Reabilitacao5,
    description: "Auxílio no desenvolvimento e reabilitação.",
  },
  {
    id: 9,
    title: "Musicoterapia",
    image: Reabilitacao8,
    description: "Auxílio no desenvolvimento e reabilitação.",
  },
  {
    id: 10,
    title: "Robótica",
    image: Reabilitacao7,
    description: "Auxílio no desenvolvimento e reabilitação.",
  },
  {
    id: 11,
    title: "Terapia Ocupacional",
    image: Reabilitacao6,
    description: "Auxílio no desenvolvimento e reabilitação.",
  },
];

export const socialAssistanceServices = [
  {
    id: 12,
    title: "Assistência Social",
    image: Assistencia1,
    description: "Serviços de assistência social.",
  },
  {
    id: 13,
    title: "Atendimento Social",
    image: Assistencia2,
    description: "Apoio e acompanhamento familiar.",
  },
];

export const orthopedicWorkshop = [
  {
    id: 14,
    title: "Tecnologia Assistiva",
    image: Ortopedica,
    description: "Confecção e manutenção de aparelhos ortopédicos.",
  },
];
